
const persistedBlocks = ['B2CProductDetailTileModel', 'B2BProductDetailTileModel', 'StoreProductDetailTileModel'];

export default function usePersistedBlocks() {
    const getIsPersistedBlock = (block: string): boolean => persistedBlocks.includes(block);

    const getRenderKey = (block: string, idx: number): string => {
        let key = block;
        if (!getIsPersistedBlock(block)) {
            key = key + idx + new Date().getTime();
        }
        return key;
    };

    return {
        getRenderKey,
    };
}
